import React from 'react';
import { useHistory } from 'react-router-dom';
import { NumericFormat } from 'react-number-format';
export default function ResourceListItem(props) {
    var _a = props.data, title = _a.title, url = _a.url, uid = _a.uid, addresses = _a.addresses, amount = _a.amount, recipient = _a.recipient;
    var _b = (addresses === null || addresses === void 0 ? void 0 : addresses[0]) || {}, city = _b.city, county = _b.county, region = _b.region, state = _b.state;
    var globalConfig = props.globalConfig, openModalItem = props.openModalItem, selectItem = props.selectItem, isSelected = props.isSelected;
    var baseRoute = globalConfig.baseRoute;
    var cleanTitle = title.replace(/[\[\]]/g, '');
    var history = useHistory();
    var location;
    if (city) {
        location = "".concat(city, ", ").concat(state);
    }
    else if (!location && county) {
        location = "".concat(county, " County, ").concat(state);
    }
    else if (!location && region) {
        location = region;
    }
    else {
        location = 'Statewide';
    }
    ;
    var handleClick = function () {
        openModalItem(uid);
        history.replace(url === null || url === void 0 ? void 0 : url.replace(baseRoute, ''));
    };
    var handleMouseOver = function () {
        selectItem([uid]);
    };
    var handleMouseLeave = function () {
        selectItem([]);
    };
    return (React.createElement("div", { className: "EventListItem".concat(isSelected ? ' selected' : ''), onClick: handleClick, onMouseOver: handleMouseOver, onMouseOut: handleMouseLeave },
        location && (React.createElement("div", { className: "EventListItem__city Heading Heading--overline" }, location)),
        React.createElement("div", { className: "EventListItem__title" },
            amount && (React.createElement("span", { className: "EventListItem__amount" },
                "$",
                React.createElement(NumericFormat, { displayType: "text", value: amount, thousandSeparator: "," }))),
            cleanTitle || recipient)));
}
;
